import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, LightThemeProvider } from '@platform-ui/design-system';
import { ReplaySubject } from 'rxjs';
import { DSButtonGroup } from './ButtonGroup';
import camelCase from 'lodash.camelcase';
import kebabCase from 'lodash.kebabcase';
/* Special Snowflake: This is a blend of the ParentElement and ContentChild abstracts. */

export var DSButton = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DSButton, _HTMLElement);

  var _super = _createSuper(DSButton);

  _createClass(DSButton, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, _, newValue) {
      var _Button$__docgenInfo, _Button$__docgenInfo$, _Button$__docgenInfo$2;

      var propName = camelCase(attrName);
      var isBooleanAttr = // @ts-ignore
      ((_Button$__docgenInfo = Button.__docgenInfo) === null || _Button$__docgenInfo === void 0 ? void 0 : (_Button$__docgenInfo$ = _Button$__docgenInfo.props[propName]) === null || _Button$__docgenInfo$ === void 0 ? void 0 : (_Button$__docgenInfo$2 = _Button$__docgenInfo$.type) === null || _Button$__docgenInfo$2 === void 0 ? void 0 : _Button$__docgenInfo$2.name) === 'boolean';

      if (isBooleanAttr) {
        this[propName] = [null, undefined].indexOf(newValue) === -1;
      } else {
        this[propName] = newValue;
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return _toConsumableArray(Object.keys(Button['__docgenInfo'].props)).map(function (prop) {
        return kebabCase(prop);
      });
    }
  }]);

  function DSButton() {
    var _this;

    _classCallCheck(this, DSButton);

    _this = _super.call(this); // @ts-ignore

    _defineProperty(_assertThisInitialized(_this), "comp", Button);

    _defineProperty(_assertThisInitialized(_this), "sub$", void 0);

    _defineProperty(_assertThisInitialized(_this), "parent", void 0);

    _defineProperty(_assertThisInitialized(_this), "mount", document.createElement('span'));

    _defineProperty(_assertThisInitialized(_this), "body$", new ReplaySubject());

    _defineProperty(_assertThisInitialized(_this), "props", {
      getBodySlot: function getBodySlot(node) {
        _this.body$.next(node);
      }
    });

    var propKeys = Object.keys(Button.__docgenInfo.props);
    propKeys.map(function (prop) {
      Object.defineProperty(_assertThisInitialized(_this), prop, {
        get: function get() {
          return this.props[prop];
        },
        set: function set(newValue) {
          this.props[prop] = newValue;
          this.render();
        }
      });
    });
    return _this;
  }

  _createClass(DSButton, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ReactDOM.render( /*#__PURE__*/React.createElement(LightThemeProvider, null, /*#__PURE__*/React.createElement(Button, this.props)), this.mount);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function render() {
        return _render.apply(this, arguments);
      }

      return render;
    }()
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;

      if (!this.sub$ && this.parentElement instanceof DSButtonGroup) {
        this.parent = this.parentElement;
        this.sub$ = this.parentElement.body$.asObservable().subscribe(function (node) {
          switch (node) {
            case 'unmount':
              {
                _this2.sub$.unsubscribe();

                delete _this2.parent;
                delete _this2.sub$;
                break;
              }

            case null:
              {
                _this2.parent.appendChild(_this2);

                break;
              }

            default:
              {
                node.appendChild(_this2);
              }
          }
        });
      } else {
        this.appendChild(this.mount);
        this.render();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.contains(this.mount)) {
        this.removeChild(this.mount);
      }

      if (!document.body.contains(this)) {
        ReactDOM.unmountComponentAtNode(this.mount);
        delete this.mount;
        this.body$.next('unmount');
      }
    }
  }]);

  return DSButton;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
//# sourceMappingURL=Button.js.map